import BaseApi from "./BaseApi";

export default class Workers extends BaseApi {
    construct() {}

    static async getAll() {
        return await Workers.getAxiosInstance().get(Workers.getApiUrl() + "/all");
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "workers";
    }
}